(function () {
  'use strict';

  // Rebuilds slider dot buttons based on actual visible columns (responsive).
  // Dawn sets sliderControlButtons once at init, so we rebuild + patch it on
  // every resize breakpoint change to keep mobile and desktop in sync.

  function rebuildDots(sliderEl) {
    var list = sliderEl.querySelector('[id^="Slider-"]');
    var counter = sliderEl.querySelector('.slider-counter--dots');
    if (!list || !counter) return;

    var slides = Array.from(list.querySelectorAll('.slider__slide'));
    if (!slides.length) return;

    // Derive the number of visible columns from actual rendered widths
    var containerW = list.offsetWidth;
    var slideW     = slides[0].offsetWidth;
    if (!slideW || !containerW) return;

    var visibleCols = Math.max(1, Math.round(containerW / slideW));
    var totalDots   = Math.max(1, slides.length - visibleCols + 1);

    // Only rebuild if dot count has changed
    var existing = counter.querySelectorAll('.slider-counter__link--dots');
    if (existing.length === totalDots) return;

    // Determine currently active page before we wipe the DOM
    var activePage = 1;
    existing.forEach(function (btn, i) {
      if (btn.classList.contains('slider-counter__link--active')) activePage = i + 1;
    });
    activePage = Math.min(activePage, totalDots);

    // Get the slider id for aria-controls
    var sliderId = list.id;

    // Rebuild
    counter.innerHTML = '';
    for (var i = 0; i < totalDots; i++) {
      var btn = document.createElement('button');
      btn.className = 'slider-counter__link slider-counter__link--dots link' +
        (i === activePage - 1 ? ' slider-counter__link--active' : '');
      btn.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + totalDots);
      if (sliderId) btn.setAttribute('aria-controls', sliderId);
      var dot = document.createElement('span');
      dot.className = 'dot';
      btn.appendChild(dot);
      counter.appendChild(btn);
    }

    // Patch Dawn's cached NodeList so arrow-click active-state still works
    sliderEl.sliderControlButtons = sliderEl.querySelectorAll('.slider-counter__link');

    // Re-attach click listeners Dawn would have set at init
    sliderEl.querySelectorAll('.slider-counter__link--dots').forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var slideWidth = slides[0].offsetWidth;
        list.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
      });
    });
  }

  function updateActiveDot(sliderEl) {
    var list  = sliderEl.querySelector('[id^="Slider-"]');
    var dots  = sliderEl.querySelectorAll('.slider-counter__link--dots');
    if (!list || !dots.length) return;

    var slides  = list.querySelectorAll('.slider__slide');
    var slideW  = slides[0] ? slides[0].offsetWidth : 0;
    if (!slideW) return;

    var page = Math.round(list.scrollLeft / slideW);
    var idx  = Math.min(Math.max(page, 0), dots.length - 1);

    dots.forEach(function (dot, i) {
      dot.classList.toggle('slider-counter__link--active', i === idx);
    });
  }

  function initSliderDots(sliderEl) {
    var list = sliderEl.querySelector('[id^="Slider-"]');
    if (!list) return;

    // Initial build (runs after layout so widths are available)
    setTimeout(function () {
      rebuildDots(sliderEl);
      updateActiveDot(sliderEl);
    }, 50);

    // Update active dot on scroll
    list.addEventListener('scroll', function () {
      updateActiveDot(sliderEl);
    }, { passive: true });

    // Rebuild on resize (debounced)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        rebuildDots(sliderEl);
        updateActiveDot(sliderEl);
      }, 150);
    });
  }

  function init() {
    document.querySelectorAll('slider-component').forEach(initSliderDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
